module.exports = __webpack_public_path__ + "img/seo_glotto_item01.ed53f31.webp";